import Option from '@/components/form/types/Option.ts';

export enum DiscountType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
}

export function getDiscountTypeOptions(): Option[] {
  return [
    { value: DiscountType.PERCENTAGE, label: 'Procentowy' },
    { value: DiscountType.FIXED_AMOUNT, label: 'Kwotowy' },
  ];
}
